import { PeriodoDeclaracionModeloEnumType } from "api/Types/PeriodoDeclaracionModeloEnum"
import { InputText } from "primereact/inputtext"
import { useTranslation } from "react-i18next"

const DevengoModelo303 = ({
  periodo,
  ejercicio,
}: {
  periodo: {
    label: string | null
    value: PeriodoDeclaracionModeloEnumType | null
  }
  ejercicio: number
}) => {
  const { t } = useTranslation()

  return (
    <div className='tw-w-full tw-h-full tw-flex tw-flex-col'>
      <div className='tw-w-full tw-gap-3 tw-min-h-14 tw-p-0 tw-flex tw-justify-start tw-items-center tw-py-1 tw-border-b tw-border-t tw-border-neutral-25 tw-px-6'>
        <div className='tw-flex tw-flex-col tw-justify-start'>
          <span className='tw-text-xs tw-text-left tw-font-medium'>
            {t("taxSummary.declaracion.devengoModelo.ejercicio")}
          </span>
          <InputText
            value={ejercicio}
            className='tw-text-sm'
            disabled
          />
        </div>
        <div className='tw-flex tw-flex-col tw-justify-start'>
          <span className='tw-text-xs tw-text-left tw-font-medium'>
            {t("taxSummary.declaracion.devengoModelo.periodo")}
          </span>
          <InputText
            value={periodo.label ?? ""}
            className='tw-text-sm'
            disabled
          />
        </div>
      </div>

      <span className='tw-text-xs tw-text-right tw-w-full tw-py-1 tw-px-6'>
        {t("taxSummary.declaracion.infoMsg")}
      </span>
    </div>
  )
}

export default DevengoModelo303
